// extracted by mini-css-extract-plugin
export default {"component":"Title_component__jlcAl","thumbnail":"Title_thumbnail__RoOH3"};